import classNames from "classnames";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import ConnectUsingQRCodeButton from "./ConnectUsingQRCodeButton";

const ConnectNewScreenBox: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { connectToScreen, } = rootStore.screensStore;
  const { theme } = rootStore.commonStore;
  const [insertedCode, setInsertedCode] = useState("");
  const [t] = useTranslation(["browse_page"], translationHookOptions);


  return (
    <div className="card col-12 h-100 customCard">
      <div className="ml-2">
        <Row className="mb-2">
          <Col xs="12" sm="8" className="mb-2">
            <Row className="pb-2">
              <h5>{t("screens_new_connect_text")}</h5>
            </Row>
            <Row>
              <input
                className="form-control-alternative w-50"
                placeholder={t("screens_new_connect_placeholder")}
                onChange={(e) => setInsertedCode(e.currentTarget.value)}
                value={insertedCode}
              ></input>
              <button
                className={classNames(
                  "ml-2 screenButton",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                    theme!.buttonTextColor
                  }`
                )}
                disabled={!insertedCode}
                onClick={() =>
                  connectToScreen(insertedCode).finally(() =>
                    setInsertedCode("")
                  )
                }
              >
                {t("screens_new_connect_button")}
              </button>
            </Row>
          </Col>
            <Col xs="12" sm="4" className="pl-0 pr-0">
              <div className=" float-sm-right">
                <ConnectUsingQRCodeButton />
              </div>
            </Col>
        </Row>
      </div>
    </div>
  );
};

export default ConnectNewScreenBox;
